"use client";

import dynamic from "next/dynamic";
import MapViewLoading from "./map-view-loading";
import { useEffect, useState } from "react";
import styles from "./map-view.module.css";

const LazyMap = dynamic(() => import("./map-libre"), {
  ssr: false,
});

export default function MapWrapper({
  location,
}: {
  location: {
    lat: number;
    long: number;
  };
}) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={styles.mapWrapper}>
      {isLoaded ? <LazyMap location={location} /> : <MapViewLoading />}
    </div>
  );
}
